import { HEARTBEAT } from 'constants/socket'
import useInterval from 'hooks/useInterval/useInterval'
import { dispatchSendSocketMessage } from 'store/dispatcher'

const CHECK_HB_INTERVAL = 60000 // ms

const useHeartbeat = () => {
    useInterval(() => {
        dispatchSendSocketMessage({ action: HEARTBEAT })
    }, CHECK_HB_INTERVAL)
}

export default useHeartbeat
